import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faThermometerHalf, 
  faWind, 
  faTint, 
  faLeaf,
  faTools,
  faCog
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/ServicePage.css';

const HlsPage: React.FC = () => {
  return (
    <div className="service-page">
      {/* Header Section */}
      <header className="service-header">
        <div className="container">
          <div className="service-header-content">
            <div className="service-icon">
              <FontAwesomeIcon icon={faThermometerHalf} />
            </div>
            <h1>HLS-Technik</h1>
            <p>
              Heizung, Lüftung und Sanitär – Komplettlösungen für optimales Raumklima und Komfort
            </p>
          </div>
        </div>
      </header>

      <div className="service-content">
        <div className="container">
          {/* Intro Section */}
          <section className="service-section">
            <h2 className="service-section-title">Fachplanung für HLS-Technik</h2>
            <div className="service-intro">
              <p>
                Im Bereich der Heizungs-, Lüftungs- und Sanitärtechnik (HLS) bietet das Ingenieurbüro Neubaur 
                umfassende Planungsleistungen für moderne und energieeffiziente Gebäudetechnik. Wir entwickeln 
                nachhaltige HLS-Anlagen, die für ein optimales Raumklima sorgen und gleichzeitig Ressourcen schonen.
              </p>
              <p>
                Unsere erfahrenen Ingenieure und Techniker planen individuelle Lösungen, die perfekt auf die 
                Anforderungen Ihres Projekts abgestimmt sind – von der ersten Konzeption bis zur detaillierten 
                Ausführungsplanung.
              </p>
            </div>
          </section>

          {/* Services Overview */}
          <section className="service-section">
            <h2 className="service-section-title">Unsere Leistungen im Bereich HLS</h2>
            
            <div className="service-features">
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faThermometerHalf} />
                </div>
                <h3 className="service-feature-title">Heizungstechnik</h3>
                <p className="service-feature-text">
                  Planung moderner Heizungsanlagen mit erneuerbaren Energien, Wärmepumpen, 
                  Brennwerttechnik und intelligenter Regelungstechnik.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faWind} />
                </div>
                <h3 className="service-feature-title">Lüftungstechnik</h3>
                <p className="service-feature-text">
                  Entwicklung von Lüftungskonzepten für optimale Luftqualität, 
                  Wärmerückgewinnung und energieeffiziente Klimatisierung.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faTint} />
                </div>
                <h3 className="service-feature-title">Sanitärtechnik</h3>
                <p className="service-feature-text">
                  Planung von Trinkwasser- und Abwasseranlagen, Regenwassernutzung 
                  und modernen Sanitärinstallationen.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faLeaf} />
                </div>
                <h3 className="service-feature-title">Energieeffizienz</h3>
                <p className="service-feature-text">
                  Optimierung der Anlagentechnik für minimalen Energieverbrauch 
                  und maximale Nachhaltigkeit.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faTools} />
                </div>
                <h3 className="service-feature-title">Wartung & Service</h3>
                <p className="service-feature-text">
                  Konzepte für die optimale Wartung und den langfristigen 
                  Betrieb der HLS-Anlagen.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faCog} />
                </div>
                <h3 className="service-feature-title">Gebäudeautomation</h3>
                <p className="service-feature-text">
                  Integration der HLS-Technik in moderne Gebäudeautomationssysteme 
                  für optimale Steuerung und Effizienz.
                </p>
              </div>
            </div>
          </section>

          {/* Process Section */}
          <section className="service-section">
            <h2 className="service-section-title">Unser Planungsprozess</h2>
            <div className="service-process">
              <div className="process-step">
                <div className="process-number">1</div>
                <div className="process-content">
                  <h3 className="process-title">Bedarfsanalyse</h3>
                  <p className="process-text">
                    Detaillierte Analyse der Gebäudeanforderungen, Nutzungsprofile und 
                    energetischen Rahmenbedingungen für die optimale Anlagenauslegung.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">2</div>
                <div className="process-content">
                  <h3 className="process-title">Konzeptentwicklung</h3>
                  <p className="process-text">
                    Basierend auf der Analyse entwickeln wir ein maßgeschneidertes HLS-Konzept 
                    für Ihr Projekt mit Fokus auf Effizienz und Nachhaltigkeit.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">3</div>
                <div className="process-content">
                  <h3 className="process-title">Detailplanung</h3>
                  <p className="process-text">
                    Wir erstellen detaillierte technische Planungen für alle HLS-Anlagen 
                    und -Systeme inklusive aller erforderlichen Berechnungen.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">4</div>
                <div className="process-content">
                  <h3 className="process-title">Ausschreibung</h3>
                  <p className="process-text">
                    Erstellung von Leistungsverzeichnissen und Unterstützung bei der 
                    Ausschreibung und Vergabe der Installationsarbeiten.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">5</div>
                <div className="process-content">
                  <h3 className="process-title">Bauüberwachung</h3>
                  <p className="process-text">
                    Während der Installationsphase überwachen wir die fachgerechte 
                    Umsetzung der HLS-Anlagen und koordinieren alle Beteiligten.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">6</div>
                <div className="process-content">
                  <h3 className="process-title">Inbetriebnahme</h3>
                  <p className="process-text">
                    Begleitung der Inbetriebnahme, Funktionsprüfungen und 
                    Einweisung der Betreiber in die Anlagentechnik.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Specializations */}
          <section className="service-section">
            <h2 className="service-section-title">Unsere Spezialisierungen</h2>
            
            <div className="specializations">
              <div className="specialization-item">
                <h3>Wärmepumpenanlagen</h3>
                <p>
                  Planung effizienter Wärmepumpensysteme für Heizung und Warmwasserbereitung 
                  mit optimaler Integration in das Gesamtsystem.
                </p>
              </div>
              
              <div className="specialization-item">
                <h3>Kontrollierte Wohnraumlüftung</h3>
                <p>
                  Entwicklung von Lüftungskonzepten mit Wärmerückgewinnung für 
                  gesunde Raumluft und minimale Energieverluste.
                </p>
              </div>
              
              <div className="specialization-item">
                <h3>Fernwärme-Anschlüsse</h3>
                <p>
                  Planung und Integration von Fernwärmeanschlüssen als nachhaltige 
                  und effiziente Wärmeversorgung.
                </p>
              </div>
              
              <div className="specialization-item">
                <h3>Regenwassermanagement</h3>
                <p>
                  Konzepte für Regenwassernutzung, Retention und nachhaltige 
                  Entwässerungssysteme.
                </p>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="service-cta">
            <h2 className="service-cta-title">Ihr Partner für HLS-Technik</h2>
            <p className="service-cta-text">
              Nutzen Sie unsere Expertise im Bereich HLS-Technik für Ihr nächstes Projekt. 
              Wir beraten Sie gerne zu energieeffizienten und nachhaltigen HLS-Lösungen.
            </p>
            <a href="/kontakt" className="btn btn-primary">
              Kontakt aufnehmen
            </a>
          </section>
        </div>
      </div>
    </div>
  );
};

export default HlsPage;







